.groupLabel {
  display: flex;
  padding: 0.5rem 0;
  align-items: flex-start;
  gap: 0;
  align-self: stretch;
  margin-bottom: 10px;
}

.createShipmentForm {
  padding-top: 0.5rem;
}

.addressPreviewText {
  width: 100%;
  text-align: right;
  color: var(--static-text-weak);
  font-size: var(--fs-small);
  margin-bottom: 10px;
}

.formItem {
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin: 1rem 0;
  align-items: center;
}

.invalidText{
  color: var(--sentiment-text-negative);
  font-size: var(--fs-small);
}

.modal {
  max-width: 1000px;
  width: 100%;
}

.modalBody {
  max-height: 75vh;
  overflow-y: scroll;
}